import CarouselWithContent from './CarouselWithContent'

export * from './CarouselWithContent'

export default CarouselWithContent
